export default __webpack_public_path__ + "static/media/search-icon.cf1c1370.svg";